/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface HeartbeatMyLearnVisit200Response
 */
export interface HeartbeatMyLearnVisit200Response {
    /**
     * 
     */
    lastSeenAt: Date;
    /**
     * 
     */
    expiresAt: Date;
}

/**
 * Check if a given object implements the HeartbeatMyLearnVisit200Response interface.
 */
export function instanceOfHeartbeatMyLearnVisit200Response(value: object): value is HeartbeatMyLearnVisit200Response {
    if ((!('lastSeenAt' in (value as Record<string, any>)) && !('last_seen_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['lastSeenAt'] === undefined && (value as Record<string, any>)['last_seen_at'] === undefined)) return false;
    if ((!('expiresAt' in (value as Record<string, any>)) && !('expires_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['expiresAt'] === undefined && (value as Record<string, any>)['expires_at'] === undefined)) return false;
    return true;
}

export function HeartbeatMyLearnVisit200ResponseFromJSON(json: any): HeartbeatMyLearnVisit200Response {
    return HeartbeatMyLearnVisit200ResponseFromJSONTyped(json, false);
}

export function HeartbeatMyLearnVisit200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeartbeatMyLearnVisit200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'lastSeenAt': (json['last_seen_at'] == null ? json['last_seen_at'] : parseDateTime(json['last_seen_at'])),
        'expiresAt': (json['expires_at'] == null ? json['expires_at'] : parseDateTime(json['expires_at'])),
    };
}

export function HeartbeatMyLearnVisit200ResponseToJSON(json: any): HeartbeatMyLearnVisit200Response {
    return HeartbeatMyLearnVisit200ResponseToJSONTyped(json, false);
}

export function HeartbeatMyLearnVisit200ResponseToJSONTyped(value?: HeartbeatMyLearnVisit200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_seen_at': value['lastSeenAt'] == null ? value['lastSeenAt'] : serializeDateTime(value['lastSeenAt']),
        'expires_at': value['expiresAt'] == null ? value['expiresAt'] : serializeDateTime(value['expiresAt']),
    };
}

